import { Component, inject } from '@angular/core';
import { RolesService } from './services/roles.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-roles',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.css'
})
export class RolesComponent {
  service = inject(RolesService)

  ngOnInit(): void {
    this.service.title.update((value) => 'Roles')
  }
}
